import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { swiperOptions } from '@src/components/swiper/base-swiper/swiper-options';
import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
import { useEffect } from 'react';
import featureList from './featureList';
class SixthPageStore extends BaseStore {
  constructor({ ...rest } = {}) {
    super();
    Object.assign(this, rest);
  }

  @observable isActive = false;

  baseSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      ...swiperOptions.default,
      autoplay: false,
      loop: true,
      loopAdditionalSlides: 1
    }
  });

  @observable featureList = featureList;

  playInAnimate() {
    this.isActive = true;
  }

  leaveInAnimate() {
    this.isActive = false;
  }

  use() {
    const funlinkData = useLayerData('part6');

    useEffect(
      () => {
        if (funlinkData) {
          // ...
        }
      },
      [funlinkData]
    );
  }
}
export default SixthPageStore;
